export default "/images/8e42e715435f150cf816d59716250282.png";